// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__35pzc","inputWrap":"CustomTip_inputWrap__1sWd5"};